import HighCharts from "highcharts";

// Highcharts v12 UMD extension modules (highcharts-more, modules/*) locate the core
// instance via `window._Highcharts`.  In Rolldown's production build the UMD IIFE that
// normally sets this global can be stripped or reordered, so the extensions silently
// receive `undefined` and fail to register series types (e.g. "polygon").
// Explicitly bridging the global here guarantees the extensions compose on the correct
// instance, mirroring the fix already applied for NoDataToDisplay (ES-module import).
(window as any)._Highcharts = HighCharts;
